import {
  FooterLinks,
  InputLabelText,
  LineSeparator,
  LogoutButton,
  StyledBKJToggleInput,
  UserEmail,
  UserInfo,
} from 'components/BKJMainNavigation/BKJMainNavigation.styled';
import { ExternalNavMenuItem } from 'components/BKJMainNavigation/src/ExternalNavMenuItem';
import { IMobileNavFooterProps } from 'components/BKJMainNavigation/src/Mobile/MobileNavFooter.types';
import { Flex } from 'components/Flex';
import { FC, Fragment, memo } from 'react';
import { useUserActions } from 'store/reducers/auth/authReducer';
import { deepEquals } from 'utils/deepEquals';
import { WhiteLabelAccessor } from 'utils/whiteLabelAccessor';
import { useTranslation } from 'hooks/useTranslation';
import { InternalNavMenuItem } from 'components/BKJMainNavigation/src/InternalNavMenuItem';
import { BKJAvatarStyled } from 'components/ActivityTab/ActivityTab.styled';
import { PAGE_URLS } from 'components/BKJMainNavigation/BKJMainNavigation.constants';
import { SessionService } from 'services';

const getHelpDeskLink = () => {
  const { whiteLabelProvider } = WhiteLabelAccessor;
  switch (whiteLabelProvider) {
    default:
      return '';
  }
};

const Component: FC<IMobileNavFooterProps> = ({
  disabled,
  isOpen,
  onClose,
  isShowDesktopItems,
  toggleDesktopItems,
}) => {
  const { userLogout } = useUserActions();
  const { t } = useTranslation();
  const onChange = () => {
    toggleDesktopItems(!isShowDesktopItems);
  };
  const user = SessionService.getUser();
  return (
    <FooterLinks>
      <Flex alignItems="center" padding="17px 0 17px 28px">
        <StyledBKJToggleInput
          variant="Switch"
          name="show_desktop_items"
          onChange={onChange}
          checked={isShowDesktopItems}
          minWidth="12px"
          width="12px"
        />
        <InputLabelText>Show desktop site</InputLabelText>
      </Flex>
      <ExternalNavMenuItem
        href={getHelpDeskLink()}
        label={t('navigation:SUPPORT')}
        icon="Question"
        disabled={disabled.current}
        isOpen={isOpen}
        onClick={(e) => {
          onClose(e);
          e.preventDefault();
          return window.open(getHelpDeskLink(), '_blank');
        }}
      />
      <InternalNavMenuItem
        path={PAGE_URLS.SETTINGS}
        label={t('navigation:SETTINGS')}
        icon="Settings"
        data-cy="NavMenuItems-Settings"
        disabled={disabled.current}
        isOpen={isOpen}
        onClick={onClose}
      />
      <Flex padding="0 10px 0 8px">
        <LineSeparator />
      </Flex>
      <Flex padding="15px 0 0 15px" alignItems="center">
        <BKJAvatarStyled
          width="48px"
          height="48px"
          fallbackAvatarColor="PrimaryDefault"
          src={user?.avatar_urls?.origin}
        />
        {isOpen && (
          <Fragment>
            <Flex flexDirection="column" padding="0 0 0 8px">
              <UserInfo>{user?.first_name}</UserInfo>
              <UserEmail>{user?.email}</UserEmail>
            </Flex>
            <LogoutButton
              label=""
              icon="Logout"
              data-cy="logout"
              disabled={disabled.current}
              isOpen={isOpen}
              onClick={(e) => {
                userLogout();
                onClose(e);
              }}
            />
          </Fragment>
        )}
      </Flex>
    </FooterLinks>
  );
};

export const MobileNavFooter = memo(Component, deepEquals);
